module.exports = __webpack_public_path__ + "img/rockets.3d812679.png";